module.exports = __webpack_public_path__ + "img/16_thawing_(white).f62cf686.svg";